<script lang="ts">
    import { _ } from "svelte-i18n"
    import { title } from "../../config"
    import { initialLocale } from "../../i18n"

    import { login, location } from "../../store"

    import ProductList from "../product/ProductList.svelte"

    import Select from "../widgets/Select.svelte"
    import Index from "../SEO/Index.svelte"

    let sort = "sort"
    let count: number

    $: search = decodeURIComponent($location.search?.substr(1))

    const regexFields = ["code", "name.de"]
    let filter
    $: {
        // escape for regex in mongo filter
        const escapedSearch = search?.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&")
        console.log("escapedSearch", escapedSearch)
        const _filter: any = {
            $or: [
                {
                    $text: {
                        $search: search,
                        $language: initialLocale,
                    },
                },
            ],
        }

        // add regexFields to $or
        regexFields.forEach((field) => {
            _filter.$or.push({
                [field]: {
                    $regex: escapedSearch,
                    $options: "i",
                },
            })
        })

        // if ($categoryPathMap["/brief-und-paketkaesten"]) {
        //     _filter["categories"] = {
        //         $nin: $categoryPathMap["/brief-und-paketkaesten"] && $categoryPathMap["/brief-und-paketkaesten"].allIds,
        //     }
        // }
        filter = _filter
    }
</script>

<Index title="{$_('search.search-for', { values: { search } })}" metaDescription="{$_('meta.description')}" />
<section class="section-type-1 section_padding">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="products_header">
                    <h3>
                        {@html $_("search.search-for-html", {
                            values: { search },
                        })}
                        {#if count}({$_("search.count-hits", {
                                values: { count },
                            })}){/if}
                    </h3>
                    <div class="orderby">
                        <Select
                            options="{[
                                { label: $_('search.sorting'), value: 'sort' },
                                {
                                    label: $_('search.by-name'),
                                    value: 'name.' + initialLocale,
                                },
                                {
                                    label: $_('search.by-price-asc'),
                                    value: 'price_net' + ($login ? '_dealer' : '_end_customer'),
                                },
                                {
                                    label: $_('search.by-price-desc'),
                                    value: '-price_net' + ($login ? '_dealer' : '_end_customer'),
                                },
                            ]}"
                            bind:value="{sort}"
                        />
                    </div>
                </div>

                <ProductList {filter} {sort} bind:count />
            </div>
        </div>
    </div>
</section>

<style lang="less">
    @import "../../css/variables.less";

    .products_header {
        .flex();
        justify-content: space-between;
    }
    .orderby {
        padding-top: 30px;
        @media (max-width: 768px) {
            width: 100%;
        }
    }
</style>
